import React from "react";
import Overview from "../components/benefitManagementPage/Overview";

export default function BenefitManagementPage(): JSX.Element {
  return <Overview />;
}
